// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2a-0";